
        import '/home/builduser/work/575538235ca6a4de/santa-editor/packages/editorSearch/views/EmptyState/EmptyState.scss.css.virtualfile';
        module.exports = {"footer":"_footer_oe3rm_1","footerLink":"_footerLink_oe3rm_8"};